import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { valetArrivalsQueue } from "./queries";
import {SESSIONS_POLL_INTERVAL_MS} from "../constants";
import {mapSessionToArrival} from "../helpers";

export default function useArrivalsQueue(facilityId) {
  const { data, loading, error, refetch } = useQuery(valetArrivalsQueue, {
    variables: { facilityId, limit: 1000 },
    skip: !facilityId,
    fetchPolicy: "cache-and-network",
    pollInterval: SESSIONS_POLL_INTERVAL_MS,
  });

  const rawItems = data?.valetSessions?.items;

  const items = useMemo(
    () => (rawItems ?? []).filter(Boolean).map(mapSessionToArrival),
    [rawItems],
  );

  return {
    items,
    count: data?.valetSessions?.count ?? 0,
    // Keep the queue on screen while a poll is in flight.
    loading: loading && !rawItems,
    error,
    refetch,
  };
}
